// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import RotatingCard from "examples/Cards/RotatingCard";
import RotatingCardFront from "examples/Cards/RotatingCard/RotatingCardFront";
import RotatingCardBack from "examples/Cards/RotatingCard/RotatingCardBack";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

// Images
import bgFront8 from "pages/Servicii/ServiciiSpeciale/CuratenieVileApartamente/sections/sections/images/bgFront8.webp";
import bgBack8 from "pages/Servicii/ServiciiSpeciale/CuratenieVileApartamente/sections/sections/images/bgBack8.webp";

function InformationHome() {
    return (
        <MKBox component="section" py={6} my={6}>
            <Container>
                <Grid
                    container
                    item
                    spacing={4}
                    alignItems="center"
                    justifyContent="center"
                    sx={{ textAlign: "center" }}
                >
                    <Grid item xs={12} lg={4} sx={{ mx: "auto" }} spacing={2}>
                        <RotatingCard>
                            <RotatingCardFront
                                image={bgFront8}
                                icon="touch_app"
                                title={
                                    <>
                                        Curățenie
                                        <br />
                                        Vile/Apartamente
                                    </>
                                }
                                description="Curățenie impecabilă pentru vile și apartamente — grijă pentru fiecare detaliu. Transformăm spațiul tău într-un loc curat, proaspăt și primitor, ca și cum ar fi casa noastră."
                            />
                            <RotatingCardBack
                                image={bgBack8}
                                title="Garanția calității"
                                description="Solicită o evaluare gratuită – fără obligații!"
                                action={{
                                    type: "internal",
                                    route: "/contact-curatenie",
                                    label: "cere o ofertă",
                                }}
                            />
                        </RotatingCard>
                    </Grid>
                    <Grid item xs={12} lg={7} sx={{ textAlign: "center" }} ml={6}>
                        <Grid
                            container
                            spacing={3}
                            sx={{ mt: { xs: 0, md: 6 } }}
                            justifyContent="center"
                            alignItems="center"
                            textAlign="center"
                        >
                            <Grid item xs={12} md={6}>
                                <DefaultInfoCard
                                    icon="construction"
                                    title="Curățenie post-construcție"
                                    description="Eliminăm complet praful, resturile și urmele de șantier, lăsând spațiul curat, igienizat și gata de utilizare."
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <DefaultInfoCard
                                    icon="home"
                                    title="Curățenie generală & de întreținere"
                                    description="Oferim servicii de curățenie generală și menaj profesional în București și Ilfov, cu echipe dedicate pentru intervenții rapide și eficiente."
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <DefaultInfoCard
                                    icon="cleaning_services"
                                    title="Curățenie exterioară"
                                    description="Întreținem curți, alei, terase și alte spații exterioare, asigurând un aspect curat, ordonat și plăcut."
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <DefaultInfoCard
                                    icon="window"
                                    title="Spălare geamuri & pereți exteriori"
                                    description="Curățăm geamurile la interior și exterior, precum și fațadele clădirilor, cu grijă pentru finisaje."
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <DefaultInfoCard
                                    icon="verified"
                                    title="Profesionalism garantat"
                                    description="Lucrăm cu personal angajat legal, cu verificări la zi, experiență relevantă și echipamente profesionale."
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <DefaultInfoCard
                                    icon="discount"
                                    title="Reduceri prin abonamente"
                                    description="Alegeți unul dintre pachetele noastre de întreținere lunară și beneficiați de 10% reducere la toate serviciile oferite."
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Container>
        </MKBox>
    );
}

export default InformationHome;
